/**
 * Açılır pencerelerin (popup/modal) ortak sınıfları — tek kaynak.
 *
 * 16.10.2026: Ekran Büyütme "Büyük Metin" açık iPhone'da (320 px genişlik, Safari çubuklarıyla
 * ~570 px yükseklik) bülten popup'ı ekrandan taştı: kapat düğmesi ekranın üstünde, abone ol
 * düğmesi alttaki mavi "Ucuz Uçuşları Göster" çubuğunun (z-50) altında kaldı; ne kapanıyor ne
 * gönderiliyordu. Kurallar:
 * - Katman, sayfadaki yapışkan çubukların (z-40/z-50) ve başlığın üstünde: z-[100].
 * - Pencere ekran yüksekliğini aşmaz (dvh: Safari çubukları hesaba katılır), aşan içerik kayar.
 * `npm run test:modals` yeni bir `fixed inset-0` pencerenin bu sınıfları kullandığını denetler.
 */

/** Karartılmış arka plan + ortalama (tıklanınca kapanan ayrı arka plan da bunu kullanır) */
export const MODAL_OVERLAY = 'fixed inset-0 z-[100] flex items-center justify-center p-4';

/** Pencerenin kendisi: ekrana sığar, gerekirse içeride kayar */
export const MODAL_PANEL = 'relative w-full max-h-[calc(100dvh-2rem)] overflow-y-auto overscroll-contain';
